import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./../assets/scss/requisition/index.scss";

import { confirmable, createConfirmation } from "react-confirm";
import {
  ApproveBlueModalIcon,
  ApproveModalIcon,
  BookIcon,
  MoneyDollarIcon,
  RecieptIcon,
} from "./Icons";
import { Dropdown, DropdownButton, Table } from "react-bootstrap";
import { map, isEmpty } from "lodash";
import { isNumber } from "lodash";
import currency from "currency.js";
import { useBackendUrl } from "../utils/hooks";

function Dialog({
  proceed,
  show,
  title = "",
  description = "",
  TransactionID,
  thermalPrinter,
}) {
  const backendUrl = useBackendUrl();

  const openPreorderAndReciept = () => {};
  return (
    <Modal
      show={show}
      onHide={() => proceed(false)}
      dialogClassName="requisition-details-modal"
      centered={true}
      animation={false}
      enforceFocus={false}
    >
      <Modal.Header closeButton />
      <Modal.Body className="approve-action">
        <div className="text-info-h">
          <ApproveBlueModalIcon className="mb-4" />
          <h2>{title}</h2>
          <p
            className="fs-6"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        <section className="row gap-4 px-3 mt-4">
          <Button
            className="p-3 col"
            variant="light-blue"
            onClick={() => proceed("Send for Approval")}
          >
            <BookIcon /> Send for Approval
          </Button>
          <Button
            className="p-3 col"
            onClick={() => proceed("Send for Payment")}
          >
            Send for Payment
          </Button>
        </section>
      </Modal.Body>
    </Modal>
  );
}

export default function ProformaChoiceDialog(props) {
  return createConfirmation(confirmable(Dialog))(props);
}
